<mat-toolbar class="header-toolbar">
  <mat-toolbar-row class="tw-flex tw-justify-between">
    <div class="header-toolbar_left-side tw-flex">
      <img class="logo tw-self-center" src="assets/core/images/bosch-logo.svg" />
      <hr class="divider divider--vertical" />
      <ng-content></ng-content>
    </div>
    <div class="tw-flex">
      <mat-form-field class="language-select">
        <ui-svg-icon [name]="iconNameList.Globe" class="menu-globe tw-cursor-pointer tw-align-middle"></ui-svg-icon>
        <mat-select [formControl]="languageControl">
          <mat-select-trigger>
            {{ languageControl.value | uppercase }}
          </mat-select-trigger>

          <mat-option *ngFor="let language of languageList" [value]="language">
            <div>
              <span>{{ 'common.language.' + language | lowercase | translate }} - {{ language | uppercase }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="user-menu-btn" [matMenuTriggerFor]="supportMenu">
        <ui-svg-icon [name]="iconNameList.UserDesktop" class="menu-globe"></ui-svg-icon>
        <div class="support">{{ 'common.field.support' | translate }}</div>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-menu #supportMenu="matMenu">
  <a mat-menu-item href="{{ raiseTicketUrl }}" target="_blank">
    <b>
      <ui-svg-icon
        [name]="iconNameList.WrenchWarning"
        class="menu-globe tw-align-middle tw-text-bosch-gray-50"
      ></ui-svg-icon>
      {{ 'common.field.raiseIssueTicket' | translate }}
    </b>
  </a>
  <a mat-menu-item href="mailto:{{ contactEmail }}">
    <b>
      <ui-svg-icon [name]="iconNameList.Mail" class="menu-globe tw-align-middle tw-text-bosch-gray-50"></ui-svg-icon>
      {{ contactEmail }}
    </b>
  </a>

  <a mat-menu-item href="tel:{{ contactPhoneNumber }}">
    <ui-svg-icon
      [name]="iconNameList.Smartphone"
      class="menu-globe tw-align-middle tw-text-bosch-gray-50"
    ></ui-svg-icon>
    {{ contactPhoneNumber }}
  </a>

  <a mat-menu-item href="{{ userGuide }}" target="_blank">
    <ui-svg-icon [name]="iconNameList.Document" class="menu-globe tw-align-middle tw-text-bosch-gray-50"></ui-svg-icon>
    {{ 'common.field.userGuide' | translate }}</a
  >
  <div class="contact-timings contact-timings__title">{{ 'common.field.phone' | translate }}:</div>

  <div class="contact-timings"><b>En:</b> 04:00 - 24:00 CET Mon - Fri</div>
  <div class="contact-timings"><b>De:</b> 08:00 - 16:00 CET Mon - Fri</div>

  <div class="contact-timings contact-timings__title">
    {{ 'common.field.tickets' | translate }}/{{ 'common.field.email' | translate }}:
  </div>
  <div class="contact-timings"><b>En:</b> 04:00 - 24:00 CET Mon - Fri</div>
  <div class="contact-timings"><b>De:</b> 08:00 - 16:00 CET Mon - Fri</div>
</mat-menu>
